import { Currency } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import type { Props } from '@swf/components/CurrencyAmount/CurrencyAmount';
import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useConvertCurrency from '@swf/core/hooks/useConvertCurrency';
import { select } from '@swf/core/store';

import styles from './BalanceAmount.scss';

interface OwnProps {
  decimalClassName?: string;
  hasSmallLineHeightClass?: boolean;
}

const BalanceAmount: React.FC<Props & OwnProps> = ({
  decimalClassName,
  hasSmallLineHeightClass,
  ...rest
}) => {
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const currency = useSelector(select.currency.get);
  const { convertedAmountValue } = useConvertCurrency(currency, rest.value / 100);

  return (
    <CurrencyAmount {...rest} {...(isPlayMoney && { currency: Currency.PlayMoney })}>
      {(parts) => {
        const decimalIndex = parts.findIndex((part) => part.type === 'decimal');
        return (
          <>
            {parts
              .slice(0, decimalIndex)
              .map((part) => part.value)
              .join('')}
            <span className={decimalClassName}>
              {parts
                .slice(decimalIndex)
                .map((part) => part.value)
                .join('')}
              {convertedAmountValue && (
                <span
                  className={classNames(
                    styles.convertedAmount,
                    hasSmallLineHeightClass ? styles.smallLineHeight : ''
                  )}
                  data-testid="header-converted-currency"
                >
                  <span>{`(${convertedAmountValue})`}</span>
                </span>
              )}
            </span>
          </>
        );
      }}
    </CurrencyAmount>
  );
};

export default BalanceAmount;
